export default __webpack_public_path__ + "static/media/photo_2.0c19f62d.jpg";